module.exports = __webpack_public_path__ + "static/professional-input-kat-stokes-54738ea83af1725033ec5750f71c4761.jpg";